export const DEPT_INFO = {
  "청년부": { slogan: "새벽이슬 같은 주의 청년", goals: ["예배의 감격 회복", "소그룹 공동체 활성화", "지역 사회 섬김"] },
  "고등부": { slogan: "세상을 변화시키는 리더", goals: ["매일 큐티 생활화", "친구 전도 축제", "진로 비전 탐색"] },
  "중등부": { slogan: "꿈꾸는 다음 세대", goals: ["성경 통독 1독", "학교 기도 모임", "부모님과 함께하는 예배"] },
  "초등부": { slogan: "예수님을 닮아가는 어린이", goals: ["암송왕 선발대회", "여름 성경 학교", "제자 훈련"] },
  "유치부": { slogan: "말씀 먹고 쑥쑥 자라요", 미리보기: ["예배 태도 바르게", "찬양 율동 배우기", "친구 사랑 실천"] },
};

// Curated Enterprise Layout
export const DEFAULT_STATS_LAYOUTS = {
  lg: [
    // Hero wide chart: Attendance Trend
    { i: 'chart_attendance', x: 0, y: 0, w: 4, h: 6 },

    // Core breakdowns
    { i: 'chart_attendance_breakdown', x: 0, y: 6, w: 2, h: 5 },
    { i: 'chart_finance_flow', x: 2, y: 6, w: 2, h: 5 },

    // Treemap (grades/departments) covering full width for visual impact
    { i: 'chart_grade_treemap', x: 0, y: 11, w: 4, h: 6 },

    // Middle tier
    { i: 'chart_capability_radial', x: 0, y: 17, w: 1, h: 5 },
    { i: 'chart_faith', x: 1, y: 17, w: 1, h: 5 },
    { i: 'chart_demographics', x: 2, y: 17, w: 2, h: 5 },

    // Activities
    { i: 'chart_visitation_heatmap', x: 0, y: 22, w: 4, h: 5 },

    // Minor details
    { i: 'chart_newcomer_funnel', x: 0, y: 27, w: 2, h: 5 },
    { i: 'chart_teacher_engagement', x: 2, y: 27, w: 1, h: 5 },
    { i: 'chart_visit_types', x: 3, y: 27, w: 1, h: 5 },
  ],
  md: [
    { i: 'chart_attendance', x: 0, y: 0, w: 2, h: 6 },
    { i: 'chart_attendance_breakdown', x: 0, y: 6, w: 2, h: 5 },
    { i: 'chart_finance_flow', x: 0, y: 11, w: 2, h: 5 },
    { i: 'chart_grade_treemap', x: 0, y: 16, w: 2, h: 6 },
    { i: 'chart_capability_radial', x: 0, y: 22, w: 1, h: 5 },
    { i: 'chart_faith', x: 1, y: 22, w: 1, h: 5 },
    { i: 'chart_demographics', x: 0, y: 27, w: 2, h: 5 },
    { i: 'chart_visitation_heatmap', x: 0, y: 32, w: 2, h: 5 },
    { i: 'chart_newcomer_funnel', x: 0, y: 37, w: 2, h: 5 },
    { i: 'chart_teacher_engagement', x: 0, y: 42, w: 1, h: 5 },
    { i: 'chart_visit_types', x: 1, y: 42, w: 1, h: 5 },
  ],
  xs: [
    { i: 'chart_attendance', x: 0, y: 0, w: 1, h: 5 },
    { i: 'chart_attendance_breakdown', x: 0, y: 5, w: 1, h: 5 },
    { i: 'chart_finance_flow', x: 0, y: 10, w: 1, h: 5 },
    { i: 'chart_grade_treemap', x: 0, y: 15, w: 1, h: 6 },
    { i: 'chart_visitation_heatmap', x: 0, y: 21, w: 1, h: 5 },
    { i: 'chart_demographics', x: 0, y: 26, w: 1, h: 5 },
    { i: 'chart_newcomer_funnel', x: 0, y: 31, w: 1, h: 5 },
    { i: 'chart_capability_radial', x: 0, y: 36, w: 1, h: 5 },
    { i: 'chart_faith', x: 0, y: 41, w: 1, h: 5 },
    { i: 'chart_teacher_engagement', x: 0, y: 46, w: 1, h: 5 },
    { i: 'chart_visit_types', x: 0, y: 51, w: 1, h: 5 },
  ]
};

export const DEFAULT_STATS_WIDGETS = {
  chart_attendance: true,
  chart_attendance_breakdown: true,
  chart_faith: true,
  chart_visit_types: true,
  chart_newcomer_funnel: true,
  chart_demographics: true,
  chart_finance_flow: true,
  chart_grade_treemap: true,
  chart_teacher_engagement: true,
  chart_visitation_heatmap: true,
  chart_capability_radial: true,
};

export const STATS_PERIOD_OPTIONS = [
  { key: '4w', label: '최근 4주' },
  { key: '3m', label: '최근 3개월' },
  { key: '1y', label: '최근 1년' },
];
